import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToBuildAndMaintainTrust');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful, then
                                                you are likely to find the following tools both insightful and
                                              e  relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color people button-link-redirect"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color people button-link-redirect"
                                                             onClick={this._savePageStatus('HowToDevelopRapport')}>How
                                                        to develop rapport</div></li>
                                                    <li><div className="link_color people button-link-redirect"
                                                             onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                        to manage your impact</div></li>
                                                    <li><div className="link_color people button-link-redirect"
                                                             onClick={this._savePageStatus('HowToCreateTeamIdentity')}>How
                                                        to create team identity</div></li>
                                                    <li><div className="link_color people button-link-redirect"
                                                             onClick={this._savePageStatus('HowToGiveFeedback')}>How
                                                        to give feedback.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Littlepage,
                                                    G. &amp; Pineault, T. (1978). Verbal, Facial, and
                                                    Paralinguistic Cues to the Detection of Truth and
                                                    Lying. <span className="subtiltereg">Personality and Social Psychology Bulletin</span>,
                                                    4(3), 461-464.</p></li>
                                                <li><p className="further_info_content">Kanawattanachai,
                                                    P. &amp; Youngjin, Y. (2005). Dynamic Nature of Trust in
                                                    Virtual Teams, <span className="subtiltereg">Sprouts: Working Papers on Information Environments, Systems and Organizations</span> ,
                                                    2(2), 41-58.</p></li>
                                                <li><p className="further_info_content">Herriot,
                                                    P. &amp; Pemberton, C. (1997). Facilitating New Deals.<span
                                                        className="subtiltereg"> Human Resource Management Journal</span>,
                                                    7, 45-56.</p></li>
                                                <li><p className="further_info_content">Murgatroyd, S.
                                                    (1985).<span className="subtiltereg"> Psychology in Action: Counselling and Helping</span>.
                                                    London. British Psychological Society and Methuen.</p></li>
                                                <li><p className="further_info_content">Hayes, J. (1991).<span
                                                    className="subtiltereg"> Interpersonal skills: Goal Directed behaviour at work</span>.
                                                    London. Harper Collins.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}